import { useEffect } from "react";
import { useAccessContext } from "@/contexts/AccessContext";
import { coreGet } from "@/services/coreApi";

export default function usePortsGeojson({
  enabled,
  cwPortGeojson,
  setCwPortGeojson,
  errorContext = ".core /geo/ports error=",
  errorLabel = "Failed to load ports:",
}) {
  const { accessContext, setAccessContext } = useAccessContext();

  useEffect(() => {
    if (!enabled || cwPortGeojson !== null) return;

    let active = true;
    const fetchPorts = async () => {
      try {
        const data = await coreGet(
          `/geo/ports`,
          accessContext,
          setAccessContext,
          errorContext,
        );
        if (!active) return;
        setCwPortGeojson(data);
      } catch (error) {
        console.error(errorLabel, error);
      }
    };

    fetchPorts();
    return () => {
      active = false;
    };
  }, [
    accessContext,
    cwPortGeojson,
    enabled,
    errorContext,
    errorLabel,
    setAccessContext,
    setCwPortGeojson,
  ]);
}
